import { z } from 'zod';
import { cursorResponseSchema } from '../common/pagination.js';
export const AuditActorKindSchema = z.enum(['person', 'service', 'system']);
// One audit event as the read surface presents it.
// - `action` is a plain string (not the enum): the vocabulary is code-enforced,
//   not a DB CHECK (ADR-020), so a retired code must still READ — the client
//   registry renders unknown actions with a safe fallback.
// - `kind` (ADR-058) is the record-shape discriminator: the client switches on it
//   to render the row from itself (created / edited / state_change / link / event /
//   deleted). A plain string for the same forward-compat reason as `action` — an
//   unknown kind falls back to a generic line.
// - `previous_value` / `new_value` are returned RAW, shaped per `kind` at write
//   time (ADR-058): a snapshot, a changed-only diff, a transition, a link's
//   added/removed edges, or an event descriptor. Referenced ids appear as
//   {id,label} pairs (historical label); coded enum values as bare codes localized
//   at render.
// - `entity_label` is the subject's display name snapshotted at the change
//   (forensic — what it was, not a live join); `actor_name` is resolved server-side.
// - `channel` is the stored `source` as written (ui · pat · app · import · system
//   — the closed list is the FILTER's, `AuditChannelSchema`); a plain string on
//   the way out for the same forward-compat reason as `action` — an unknown value
//   renders as a generic channel, never fails the page.
export const AuditEventSchema = z
    .object({
    id: z.string(),
    created_at: z.string(),
    action: z.string(),
    kind: z.string(),
    entity_type: z.string(),
    entity_id: z.string().nullable(),
    entity_label: z.string().nullable(),
    actor_id: z.string().nullable(),
    actor_name: z.string().nullable(),
    actor_kind: AuditActorKindSchema,
    channel: z.string(),
    correlation_id: z.string().nullable(),
    changed_fields_count: z.number().int().nonnegative(),
    previous_value: z.record(z.string(), z.unknown()).nullable(),
    new_value: z.record(z.string(), z.unknown()).nullable(),
    ip_address: z.string().nullable(),
    user_agent: z.string().nullable(),
})
    .strict();
export const AuditListResponseSchema = cursorResponseSchema(AuditEventSchema);
